import { useEffect } from 'react';
import { ConfigurationSpreadsheets } from 'common/types/scalarSpreadsheet';
import { WEIGHTED_SHARE_VALUES_COLUMN } from 'pages/ValuationsAllocation/common/constants/allocation';
import { ALLOCATION_WEIGHTED_SHARE_VALUES_SPREADSHEET_SECURITY_TOTAL_KEY } from 'pages/ValuationsAllocation/common/constants/weightedShareValues';

type UseFirmTotalProps = {
  weightedShareValuesSpreadsheets: ConfigurationSpreadsheets;
  getCurrentFirmTotal: (wsvSpreadsheets: ConfigurationSpreadsheets[]) => void;
};

const useFirmTotal = ({ weightedShareValuesSpreadsheets, getCurrentFirmTotal }: UseFirmTotalProps) => {
  // Extract dependency for weighted_share_value_cell values.
  // Tracks weighted_share_value_cell values to trigger firm total updates.
  // Not wrapped in useMemo since changes occur deep within weightedShareValuesSpreadsheets.
  const weightedShareValueCellValues = Object.values(weightedShareValuesSpreadsheets?.cells ?? {})
    .filter(cell => cell?.columnLegend === WEIGHTED_SHARE_VALUES_COLUMN
      && cell.alias === ALLOCATION_WEIGHTED_SHARE_VALUES_SPREADSHEET_SECURITY_TOTAL_KEY)
    .map(cell => cell.value)
    .join(',');

  useEffect(() => {
    if (weightedShareValuesSpreadsheets) {
      getCurrentFirmTotal([weightedShareValuesSpreadsheets]);
    }
  }, [weightedShareValuesSpreadsheets, getCurrentFirmTotal, weightedShareValueCellValues]);
};

export default useFirmTotal;
